import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { makeRequest } from "../makeRequest";
import type { RequestOptions } from "../makeRequest"; // 👈 export it

export function useFetchQuery<T = any>(
  queryKey: readonly unknown[],
  endpoint: string,
  options?: Omit<UseQueryOptions<T, Error>, "queryKey" | "queryFn"> & {
    params?: Record<string, any>;
    request?: RequestOptions; // 👈 NEW
  }
) {
  return useQuery<T, Error>({
    queryKey,
    queryFn: async () => {
      const res = await makeRequest<T>(endpoint, {
        method: "GET",
        query: options?.params,
        ...options?.request, // 👈 forward everything
      });

      if (!res) throw new Error("Empty response");
      return res;
    },
    staleTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    ...options,
  });
}